<template>
    <div>
        <v-container
            v-scroll="onScroll"
            class="print-header-wrapper">
            <v-layout>
                <p class="title font-weight-bold indigo--text text--darken-2 mb-0">
                    {{ program.title }}</p>
                <v-flex>
                <v-btn @click="printImage" style="float: right" color="primary"
                       class="d-print-none text-right mb-1">
                    <v-icon class="mr-1">mdi-printer</v-icon>
                    印刷する
                </v-btn>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>

        <v-container class="pdf-wrapper page-no-break"
                     v-for="exercise in program.exercises"
                     :key="exercise.id">

            <span class="headline">{{ exercise.title }}</span>
            <v-container>
                <div style="height: 600px;position: relative;" class="mt-2">
                    <img width="8   00" style="margin: 0 auto; width: 800px;" :src="getImage(exercise.id)"/>
                </div>
            </v-container>
        </v-container>

        <v-fab-transition>
            <v-btn
                class="scroll-button d-print-none"
                v-show="isscrollButtomShow()"
                color="primary"
                dark
                fixed
                bottom
                large
                right
                fab
                @click="printImage"
            >
                <v-icon>mdi-printer</v-icon>
            </v-btn>
        </v-fab-transition>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'ExerciseDetail',
        data() {
            return {
                program: {},
                offsetTop: 0
            };
        },
        beforeCreate: function() {
            document.title = "運動マニュアル印刷 | 自宅でできる介護リハビリ - リハプラン";
            document.querySelector("meta[property='og:title']").setAttribute('content', "運動マニュアル印刷 | 自宅でできる介護リハビリ - リハプラン");
            document.querySelector("meta[name='description']").setAttribute('content', "リハプランの特設サイト「自宅でできる介護リハビリ」の運動マニュアルを確認・印刷する場合はこちらです。");
            document.querySelector("meta[property='og:description']").setAttribute('content', "リハプランの特設サイト「自宅でできる介護リハビリ」の運動マニュアルを確認・印刷する場合はこちらです。");
            document.querySelector("meta[name='keywords']").setAttribute('content', "自宅でできる,介護リハビリ,運動マニュアル,リハプラン");
            document.querySelector("link[rel='canonical']").setAttribute('href', "https://rehaplan.jp/keeprehab/content");
        },
        mounted: function () {
            if (!this.$login.isSignIn()) {
                this.$router.push({path: '/keeprehab/login'});
            }
            // Google Analitics;
            this.$ga.set('dimension1', this.$login.getCurrentUser());
            this.$ga.event({
                eventCategory: '【STOP_COVID_19】詳細画面を閲覧',
                eventAction: `【STOP_COVID_19】詳細画面を閲覧: program_id: ${this.getProgramId()}`,
                eventLabel: '【STOP_COVID_19】詳細画面を閲覧'
            });
            this.loadPdf();
            this.$emit('back-icon-show');
        },
        methods: {
            /**
             *  100px 以上スクロールしたら、Button を表示する。
             */
            isscrollButtomShow() {
                return this.offsetTop > 100;
            },
            onScroll(e) {
                let document_ = e.target;
                if (document_.scrollingElement) {
                    this.offsetTop = document_.scrollingElement.scrollTop;
                } else if (document_.documentElement) {
                    this.offsetTop = document_.documentElement.offsetTop;
                } else {
                    this.offsetTop = document_.body.offsetTop;
                }
            },
            getImage(pdfId) {
                return `https://cdn.rehaplan.jp/exercise/jpg/${pdfId}.jpg`;
            },
            loadPdf() {
                let self_ = this;
                let url_ = self_.$invokeUrlMaker.create(`exercise/detail/${this.getProgramId()}`);
                axios.get(
                    url_
                ).then(function (res) {
                    if (res.data.length === 0) {
                        alert('選択したプログラムは存在しません');
                        self_.$router.push({path: '/keeprehab/index'});
                    }
                    self_.program = res.data.data[0];
                }).catch(
                    function () {
                        alert('エラーが発生しました。');
                        self_.$router.push({path: '/keeprehab/index'});
                    }
                );
            },
            printImage() {
                this.$ga.event({
                    eventCategory: '【STOP_COVID_19】詳細画面を印刷',
                    eventAction: `【STOP_COVID_19】詳細画面を印刷: program_id: ${this.getProgramId()}`,
                    eventLabel: '【STOP_COVID_19】詳細画面を印刷'
                });
                window.print();
            },

            onBack() {
                this.$router.go(-1);
            },

            getProgramId() {
                return this.$route.params['id'];
            }
        }
    };
</script>
<style>
    .print-header-wrapper {
        width: 1200px !important;
    }

    .pdf-wrapper {
        width: 810px !important;
        margin: 0 auto !important;
    }

    @media print {
        @page {
            size: A4;
        }

        .page-no-break {
            page-break-inside: avoid !important;
        }

        .v-content {
            padding: 0 !important;
        }

        .print-header-wrapper {
            padding: 0 !important;
        }

        .pdf-wrapper {
            width: 95% !important;
            margin: 0 auto !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/exercise/Detail.vue